(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ff-shipping-promo"] && !Shopify.designMode) return;
  try {
    (()=>{const banner=document.querySelector('[data-ff-promo-end]');if(!banner)return;const expires=Number(banner.dataset.ffPromoEnd)*1000;function update(){const remaining=expires-Date.now();if(remaining<=0){banner.hidden=true;const fallback=document.querySelector('[data-ff-promo-fallback]');if(fallback)fallback.hidden=false;}else setTimeout(update,Math.min(remaining,2147483647));}update();document.addEventListener('visibilitychange',()=>{if(!document.hidden&&Date.now()>=expires)update();});})();
  } catch(e) { console.error(e); }
})();

})();
